import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { translations, t } from "@/i18n/translations";
import { scrollToAnchor } from "@/lib/smoothScroll";

/**
 * Botão "Agendar Demonstração" sempre acessível: aparece após o
 * primeiro viewport e some quando o formulário de contato está visível.
 */
const FloatingCTA = () => {
  const { lang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const contact = document.querySelector("#contact");
    let contactInView = false;

    const io = contact
      ? new IntersectionObserver(
          ([entry]) => {
            contactInView = entry.isIntersecting;
            setVisible(window.scrollY > window.innerHeight * 0.8 && !contactInView);
          },
          { threshold: 0.15 }
        )
      : null;
    if (contact && io) io.observe(contact);

    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8 && !contactInView);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      io?.disconnect();
    };
  }, []);

  return (
    <button
      onClick={() => scrollToAnchor("#contact")}
      aria-label={t(translations.hero.cta, lang)}
      className={`cta-ping fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex items-center gap-2 rounded-full bg-[hsl(194,100%,47%)] px-4 py-2.5 text-xs md:px-5 md:py-3 md:text-sm font-display font-semibold text-[hsl(222,47%,6%)] shadow-[0_0_30px_hsl(194,100%,47%,0.4)] transition-all duration-500 hover:scale-105 hover:shadow-[0_0_45px_hsl(194,100%,47%,0.6)] ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-16 opacity-0"
      }`}
    >
      <CalendarClock className="h-4 w-4" />
      {t(translations.hero.cta, lang)}
    </button>
  );
};

export default FloatingCTA;
